<template>
  <page-content v-if="hasPermission('product_detail_view')" page-title="Cân chỉnh số lượng hàng tồn kho sản phẩm của shop">
    <panel ref="panel" show-close show-collapse title="Điều kiện xóa sản phẩm">
      <c-form ref="form">
        <b-row>
          <b-col>
            <c-select2 v-model.number="model.shopOrder"
                       label="Shop"
                       placeholder="Nhập tên shop hoặc mã shop"
                       uri="cms/api/v1.0/select2/shop"
                       validate-rules="required"
            />
          </b-col>
          <b-col>
            <c-select2 v-if="model.shopOrder"
                       v-model.number="model.warehouseId"
                       :uri="urlGetShopWarehouseSelect2"
                       label="Kho của shop"
                       placeholder="Nhập tên kho của shop"
            />
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <c-input v-model="model.productId" label="ID Sản phẩm"/>
          </b-col>
          <b-col>
            <c-input v-model="model.sku" label="SKU"/>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <c-input v-model="model.productName" label="Tên sản phẩm"/>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="text-center">
            <button class="btn btn-success" @click="search(false)">
              <i class="fas fa-search"></i> Tìm kiếm
            </button>

          </b-col>
        </b-row>

      </c-form>
    </panel>

    <panel v-show="showResultList" ref="resultPanel" show-collapse title="Kết quả tìm kiếm">
      <template #btn>
        <li>
          <a v-b-tooltip.hover title="Load lại dữ liệu" @click="$refs.table.reload()">
            <i class="fas fa-sync-alt"></i>
          </a>
        </li>
        <li>
          <a v-b-tooltip.hover title="Hiển thị thông tin tìm kiếm" @click="showFormSearch = !showFormSearch">
            <i class="fas fa-search"></i>
          </a>
        </li>
      </template>
      <c-table ref="table"
               :data-filter="model"
               :header-configs="[
                   {text: '#', width: '50px'},
                   {text: 'ID sản phẩm', sortField:'productId', sortable: true},
                   {text: 'Tên sản phẩm', sortField:'productName', sortable: true},
                   {text: 'SKU', sortField:'sku', sortable: true},
                   {text: 'Tên kho', sortField:'warehouseName', sortable: true},
                   {text: 'Tồn có thể bán', sortField:'totalAvailable', sortable: true},
                   {text: 'Tồn chờ xuất', sortField:'totalFreeze', sortable: true},
                   {text: 'Tổng nhập', sortField:'totalIn', sortable: true},
                   {text: 'Tổng xuất', sortField:'totalOut', sortable: true},
                   {text: 'Thao tác', width: '150px'},
               ]"
               lazy
               uri="/cms/api/v1.0/products/get-all-product-detail"
      >
        <template #button>
        </template>
        <template #default="{item, index}">
          <td class="text-right">{{ index }}</td>
          <td>{{ item.productId }}</td>
          <td>{{ item.productName }}</td>
          <td>{{ item.sku }}</td>
          <td>{{ item.warehouseName }}</td>
          <td class="text-right">{{ item.totalAvailable }}</td>
          <td class="text-right">{{ item.totalFreeze }}</td>
          <td class="text-right">{{ item.totalIn }}</td>
          <td class="text-right">{{ item.totalOut }}</td>
          <td class="text-center">
            <b-button
                class="btn btn-icon"
                title="Sửa số lượng tồn"
                type="button"
                variant="warning"
                @click="openDialog(item)"
                v-if="hasPermission('product_detail_update')"
            >
              <i class="fas fa-pencil"></i>
            </b-button>

            <b-button
                class="btn btn-icon"
                title="Xóa sản phẩm trong kho"
                type="button"
                variant="danger"
                @click="openDeleteDialog(item)"
                v-if="hasPermission('product_detail_delete')"
            >
              <i class="fas fa-trash-alt"></i>
            </b-button>

          </td>
        </template>
      </c-table>
    </panel>

    <update-inventory-dialog ref="dialog"/>
    <confirm-delete-product-detail ref="deleteDialog"/>

  </page-content>
</template>

<script>
import UpdateInventoryDialog from "@/pages/Products/UpdateInventoryDialog";
import ConfirmDeleteProductDetail from "@/pages/Products/ConfirmDeleteProductDetail";

export default {
  name: "Inventory",
  components: {ConfirmDeleteProductDetail, UpdateInventoryDialog},
  data() {
    return {
      model: {
        shopOrder: null,
        warehouseId: null,
        productId: null,
        sku: null,
        productName: null,
      },
      showResultList: false,
    }
  },
  computed: {
    urlGetShopWarehouseSelect2() {
      if (this.model.shopOrder) {
        return `cms/api/v1.0/shop-warehouse/get/select2/all?shopOrder=${this.model.shopOrder}`
      } else {
        return null;
      }
    }
  },
  methods: {
    search() {
      this.$refs.form.validate()
          .then(() => {
            this.$refs.table.reload()
                .then(success => {
                  this.showResultList = true;
                })
          })

    },
    openDialog(item) {
      this.$refs.dialog.open(item);
    },
    openDeleteDialog(item) {
      this.$refs.deleteDialog.open(item);
    }
  }
}
</script>

<style scoped>

</style>